<script lang="ts">
	import { createEventDispatcher } from 'svelte'
	import { scale, slide } from 'svelte/transition'
	import { elasticOut } from 'svelte/easing'

	const dispatch = createEventDispatcher()
	export let customize = false
	export let value = 2.5
	export let editable = true
	export let emoji = '⭐️'
	export let fontSize = '1.5rem'

	$: displayRating = value

	let touchX = 0
	let touchStart = 0
	let touching = false
	let control: HTMLElement
	let over = false

	$: emojiString = `${emoji}${emoji}${emoji}${emoji}${emoji}`
	$: width = displayRating * 2 * 10

	const roundHalf = (num: number) => Math.ceil(num * 2) / 2

	const onClick = (e: MouseEvent) => {
		if (!editable) return
		value = calcRating(e.offsetX)
		over = false
		onTouchEnd()
	}

	const calcRating = (x: number) => {
		let val = roundHalf(x / (control.getBoundingClientRect().width / 10) / 2)
		if (val < 0) val = 0
		if (val > 5) val = 5
		return val
	}

	const onTouchStart = (e: TouchEvent) => {
		showCustomize()
		if (!editable) return

		if (e.targetTouches.length > 0) {
			let touch = e.targetTouches.item(0)
			if (touch) {
				touching = true
				touchStart = control.offsetLeft
				touchStart = touchX = touch.clientX - control.getBoundingClientRect().x
				value = calcRating(touchStart)
			}
		}
	}
	const onTouchMove = (e: TouchEvent) => {
		if (!editable) return

		if (e.targetTouches.length > 0) {
			let touch = e.targetTouches.item(0)
			if (touch) {
				touchX = touch.clientX - control.getBoundingClientRect().x
				value = calcRating(touchX)
			}
		}
	}
	const onTouchEnd = () => {
		if (!editable) return

		touching = false
		updateStars(displayRating)
		hideCustomize()
	}
	let _showCustomize = false
	const showCustomize = () => {
		if (customize) _showCustomize = true
	}
	const hideCustomize = () => {
		setTimeout(() => {
			_showCustomize = false
		}, 4000)
	}
	const onMouseEnter = (e: MouseEvent) => {
		showCustomize()
		if (!editable) return
		over = true
	}
	let x = 0
	const onMouseMove = (e: MouseEvent) => {
		if (!editable || !over) return

		if (e.offsetX < 10) displayRating = 0
		else displayRating = calcRating(e.offsetX)

		touching = true
	}

	const onMouseLeave = () => {
		if (!editable) return

		width = value * 2 * 10
		displayRating = value
		over = false
		touching = false
		hideCustomize()
	}

	const updateStars = (newStars: number) => {
		if (!editable) return

		value = newStars
		dispatch('change', value)
	}
</script>

{#if emoji}
	<button
		on:mousemove={onMouseMove}
		on:mouseenter={onMouseEnter}
		on:mouseleave={onMouseLeave}
		on:touchstart={onTouchStart}
		on:touchend={onTouchEnd}
		on:touchmove={onTouchMove}
		bind:this={control}
		on:click={onClick}
		class="flex w-fit relative select-none {editable ? 'cursor-pointer' : 'cursor-default'}
	"
	>
		<span
			style:filter="grayscale(1)"
			class="opacity-[50%] w-fit whitespace-nowrap"
			style:font-size={fontSize}
			style:line-height={fontSize}
		>
			{emojiString}
		</span>
		<div
			style:font-size={fontSize}
			style:line-height={fontSize}
			style:width={`${width}%`}
			class="absolute left-0 overflow-hidden whitespace-nowrap"
		>
			<span>{emojiString}</span>
		</div>
		{#if touching}
			<div
				in:scale|global={{ easing: elasticOut, duration: 500 }}
				class="absolute w-10 -top-1 -left-12 text-center component-base p-2 "
			>
				{displayRating}
			</div>
		{/if}
	</button>
	{#if _showCustomize && customize}
		<div in:slide|global out:slide|global class="absolute left-full">
			<button class="btn btn-black dark:btn-white text-xs" on:click={() => dispatch('customize')}>Customize</button
			>
		</div>
	{/if}
{/if}
